<template>
  <div class="w-100 pt3-ns pt2 ph3 textColor">
    <div class="flex justify-center items center textColor">
      <h1 @click="setFeaturedPlaylist(); playFirstTrack()" class="fw2 f5 f4-ns bg-black-90 w-100 white pv1 ph3 ml2-l mt3 pointer textColor">
        <span class="ttu pr3 di-ns flex justify-center "><font-awesome-icon class="mr2" icon="play" size="sm"/>{{ $t("app.featuredPlaylist.title") }} </span>
        <div class="f5 fw1 pr2 di-ns flex justify-center ">
          <span class="accent">{{ $t("app.featuredPlaylist.createdBy")}} </span>
          <span class="accent">{{ featuredPlaylist.name }}</span>
        </div>
      </h1>
    </div>
    <div v-show="loading" class="flex justify-center h5 w-100 mv3">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div class="pv2 ph4-ns ph2 flex flex-column items-center">
      <div class="flex flex-wrap justify-center w-100">
        <div class="image-container flex item-center justify-center justify-start-ns mw-25">
          <img v-show="featuredPlaylistImg" class="w-100 h-100" :src="featuredPlaylistImg">
        </div>
        <p class="pa2 ma0 tj f6">{{featuredPlaylist.text}}</p>
      </div>
      <carousel :per-page="1" paginationActiveColor="#E6007E" paginationColor="#ccc"
                :perPageCustom="[[479,2],[768, 3], [1240, 4]]"
                :loop="true"
                :autoplay="true" 
                ref="carousel"
                :autoplayTimeout="3500"
                :navigationEnabled="true" class="w-100-ns w-90 carousel">
        <slide v-for="track in featuredPlaylist.tracks" :key="track.id" class="ph2 pt2 w-100 flex justify-center">
          <home-track-card @playTrack="playTrackHandler" :track="track"/>
        </slide>
      </carousel>
    </div>
  </div>
</template>

<script>
  import consts from '@/consts'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
  import {mapActions, mapGetters} from 'vuex'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import HomeTrackCard from './HomeTrackCard.vue'

  export default {
    name: 'featured-playlist',
    data () {
      return {
        featuredPlaylist: {},
        featuredPlaylistImg: null,
        color: '#808080',
        size: '30px'
      }
    },
    components: {
      FontAwesomeIcon,
      ClipLoader,
      HomeTrackCard
    },
    created () {
      this.getFeaturedPlaylist().then((data) => {
        this.featuredPlaylist = data
        this.featuredPlaylistImg = consts.MEDIA_BASE_URL + this.featuredPlaylist.image
      }).catch((e) => {
        this.$toasted.show(e, {type: 'error'})
      })
    },
    computed: {
      ...mapGetters('player', [
        'isPlaying'
      ]),
      loading () {
        return this.$loading.isLoading('playlist getFeaturedPlaylist')
      }
    },
    methods: {
      ...mapActions('player', [
        'setPlaylist',
        'playFirstTrack',
        'changeTrack'
      ]),
      ...mapActions('playlist', [
        'getFeaturedPlaylist'
      ]),
      setFeaturedPlaylist () {
        if (this.featuredPlaylist.tracks) {
          this.setPlaylist(this.featuredPlaylist.tracks)
        }
      },
      playTrackHandler (event) {
        this.setFeaturedPlaylist()
        this.changeTrack(event)
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .vinyl {
    animation: 1.5s linear infinite vinyl-rotation;
  }

  .image-container {
    width: 200px;
    height: 200px;
    img{
      object-fit: cover;
    }
  }

  p {
    max-width: 75%;
  }

  @keyframes vinyl-rotation {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media screen and (max-width: 695px) {
    p {
      max-width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/home/FeaturedPlaylist.vue